import {isEmpty} from 'lodash';
import React, {useState} from 'react';
import ReactDOM from 'react-dom';
import {useSelector} from 'react-redux';
import {compose} from 'redux';

import styles from './RMLink.module.scss';
import config from '../../config/config';
import {isDescendant} from '../../utils/dom-utils';

const RMLink = () => {
  const [showRMInfo, setShowRMInfo] = useState(false);

  const startOutsideClickListener = () => {
    window.addEventListener('click', outsideClickHandler);
  };

  const stopOutsideClickListener = () => {
    window.removeEventListener('click', outsideClickHandler);
  };

  const outsideClickHandler = (event) => {
    if (showRMInfo && !isDescendant(ReactDOM.findDOMNode(this), event.target)) {
      setShowRMInfo(false);
    }
  };

  const toggleHidden = () => {
    if (showRMInfo) {
      stopOutsideClickListener();
    } else {
      startOutsideClickListener();
    }
    setShowRMInfo(!showRMInfo);
  };

  const manager = useSelector((state) => state.userManager.manager);
  if (isEmpty(manager)) {
    return null;
  }
  return (
    <div className={styles['rm-link']}>
      <a
        href={`${config.url}/personal-investing/help/contact/index.html`}
        rel="noopener noreferrer"
        target="_blank"
        className={styles['contact-us-link']}
      >
        Contact us
      </a>{' '}
      for help with your Auto-RMD.
    </div>
  );
};

export default compose(RMLink);
